import { link, tooltip, icon } from "../cell-renderers";
import * as helpers from "../cell-renderers/helpers";
import { unixTimestampFormatter } from "../../utils";

/**
 * Creates a DataTables column config object from the provided column model
 * array. Also attaches link and tooltip behaviors at the individual cell level
 * as needed.
 *
 * @param {Array} columns
 * @param {String} linkClassName
 */
const columnConfigurator = (columns = [], linkClassName, route) =>
  columns.map((column) => {
    const elementId = column.elementId;
    return {
      data: elementId,
      // sets the cell renderer for a row
      // see Computed Values: http://datatables.net/manual/orthogonal-data
      render: (data, type, row) => {
        if (!data) {
          /**
           * This error occurs when the column list contains a
           * different set of columns than the data received from the
           * report service.
           */
          console.warn(
            "Display data is missing for a %s column. The likely cause is a column model mismatch.",
            type,
            row
          );
          return "";
        }

        if ("display" === type) {
          // when column type is a date, a unix timestamp is expected
          if ("date" === column.type) {
            data.value = unixTimestampFormatter(data.value);
          }

          if (_.has(data, "url")) {
            // inject return route if needed
            const shouldReturn = !!data.url.refresh || false;
            data.returnRoute = shouldReturn ? route : false;
            data.returnRouteRefresh = shouldReturn;

            // override default child-grid className when a url.type 'modal' is linked
            data.className =
              "modal" === data.url.type ? "drilldown" : linkClassName;
            // render link
            return link(data);
          }

          if (_.has(data, "tooltip")) {
            // render tooltip
            return tooltip(data);
          }

          // does the current route have a column-icon map?
          const routeWithIcons = helpers.routeHasIcons(route);
          if (routeWithIcons) {
            // does the current column have an icon set?
            const columnHasIcons = helpers.columnHasIcons(
              routeWithIcons,
              elementId
            );
            if (columnHasIcons) {
              // render icon
              return icon(routeWithIcons, elementId, data);
            }
          }
        }

        // return raw value
        return data.value || "";
      },

      name: elementId,
      // set title tooltips when the name and values are different
      title:
        column.name === column.tooltip
          ? column.name
          : `<abbr
							data-toggle="tooltip"
							data-placement="top"
							data-container="body"
							title="${column.tooltip}"
						>${column.name}</abbr>`,
      orderable: column.orderable,
      searchable: column.searchable,
      visible: column.visible,
      // add elementId to className to help testers select columns by name
      className: elementId,
    };
  });

export { columnConfigurator as default };
